module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-box"
  }, [_c('div', {
    ref: "list",
    staticClass: "pl-list",
    on: {
      "scroll": _vm.handleListScroll
    }
  }, [_vm._l((_vm.list), function(c, ci) {
    return _c('div', {
      key: c.id,
      staticClass: "pl-item"
    }, [(c.avatar) ? _c('img', {
      staticClass: "pl-avatar",
      attrs: {
        "src": c.avatar
      }
    }) : _c('div', {
      staticClass: "pl-avatar pl-avatar--empty"
    }), _vm._v(" "), _c('div', {
      staticClass: "pl-main"
    }, [_c('div', {
      staticClass: "pl-name"
    }, [_vm._v(_vm._s(c.nickName))]), _vm._v(" "), _c('div', {
      staticClass: "pl-content"
    }, [_vm._v(_vm._s(c.content))]), _vm._v(" "), _c('div', {
      staticClass: "pl-meta"
    }, [_c('span', {
      staticClass: "pl-time"
    }, [_vm._v(_vm._s(_vm.formatTime(c.createTime)))]), _vm._v(" "), _c('span', {
      staticClass: "pl-reply-btn",
      on: {
        "click": function($event) {
          return _vm.startReply(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.huifu')))]), _vm._v(" "), (_vm.isMine(c)) ? _c('span', {
      staticClass: "pl-del",
      on: {
        "click": function($event) {
          return _vm.delComment(c, ci)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.shanchu')))]) : _vm._e()]), _vm._v(" "), (c.childs.length) ? _c('div', {
      staticClass: "pl-childs"
    }, [_vm._l((c.childs), function(r, ri) {
      return _c('div', {
        key: r.id,
        staticClass: "pl-child"
      }, [(r.avatar) ? _c('img', {
        staticClass: "pl-child-avatar",
        attrs: {
          "src": r.avatar
        }
      }) : _c('div', {
        staticClass: "pl-child-avatar pl-avatar--empty"
      }), _vm._v(" "), _c('div', {
        staticClass: "pl-main"
      }, [_c('div', {
        staticClass: "pl-name"
      }, [_vm._v(_vm._s(r.nickName))]), _vm._v(" "), _c('div', {
        staticClass: "pl-content"
      }, [_vm._v(_vm._s(r.content))]), _vm._v(" "), _c('div', {
        staticClass: "pl-meta"
      }, [_c('span', {
        staticClass: "pl-time"
      }, [_vm._v(_vm._s(_vm.formatTime(r.createTime)))]), _vm._v(" "), _c('span', {
        staticClass: "pl-reply-btn",
        on: {
          "click": function($event) {
            return _vm.startReply(c, r)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('all.huifu')))]), _vm._v(" "), (_vm.isMine(r)) ? _c('span', {
        staticClass: "pl-del",
        on: {
          "click": function($event) {
            return _vm.delReply(c, r, ri)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('all.shanchu')))]) : _vm._e()])])])
    }), _vm._v(" "), (c.childHasMore) ? _c('div', {
      staticClass: "pl-child-more",
      on: {
        "click": function($event) {
          return _vm.loadChilds(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.childMoreText(c)))]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (c.replyNumber > 0 && c.childs.length === 0) ? _c('div', {
      staticClass: "pl-expand",
      on: {
        "click": function($event) {
          return _vm.loadChilds(c)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.chakanhuifu')) + " (" + _vm._s(c.replyNumber) + ")")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.loaded && !_vm.loading && _vm.list.length === 0) ? _c('kong') : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "pl-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.jiazaizhong')))]) : _vm._e(), _vm._v(" "), (!_vm.hasMore && _vm.list.length > 0) ? _c('div', {
    staticClass: "pl-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.meiyougengduo')))]) : _vm._e()], 2), _vm._v(" "), (_vm.replyTarget) ? _c('div', {
    staticClass: "pl-reply-chip"
  }, [_c('span', {
    staticClass: "pl-reply-chip-text"
  }, [_vm._v(_vm._s(_vm.replyChipText))]), _vm._v(" "), _c('svg', {
    staticClass: "pl-reply-chip-close",
    attrs: {
      "viewBox": "0 0 24 24"
    },
    on: {
      "click": function($event) {
        _vm.replyTarget = null
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "fill": "rgba(255,255,255,0.15)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.5 8.5l7 7M15.5 8.5l-7 7",
      "stroke": "#FFFFFF",
      "stroke-width": "1.8",
      "stroke-linecap": "round"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.emojiShow) ? _c('div', {
    staticClass: "pl-emoji-panel"
  }, [_c('div', {
    staticClass: "pl-emoji-grid"
  }, _vm._l((_vm.emojiList), function(e, ei) {
    return _c('span', {
      key: ei,
      staticClass: "pl-emoji-item",
      on: {
        "click": function($event) {
          return _vm.pickEmoji(e)
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-input-bar"
  }, [_c('div', {
    staticClass: "pl-emoji-btn",
    on: {
      "click": _vm.toggleEmoji
    }
  }, [_c('div', {
    staticClass: "pl-emoji-face",
    class: {
      'pl-emoji-face--active': _vm.emojiShow
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "pl-input",
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pl-send",
    class: {
      'pl-send--loading': _vm.submitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fasong')))])]), _vm._v(" "), (_vm.delTarget) ? _c('div', {
    staticClass: "pl-confirm"
  }, [_c('div', {
    staticClass: "pl-confirm-card"
  }, [_c('div', {
    staticClass: "pl-confirm-text"
  }, [_vm._v(_vm._s(_vm.$t('all.shanchupinglun')))]), _vm._v(" "), _c('div', {
    staticClass: "pl-confirm-btns"
  }, [_c('div', {
    staticClass: "pl-confirm-btn pl-confirm-btn--cancel",
    on: {
      "click": function($event) {
        _vm.delTarget = null
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.quxiao')))]), _vm._v(" "), _c('div', {
    staticClass: "pl-confirm-btn pl-confirm-btn--ok",
    on: {
      "click": _vm.confirmDel
    }
  }, [_vm._v(_vm._s(_vm.$t('all.queding')))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-581be669"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pinglun/pinglun.vue
// module id = 1030
// module chunks = 1